'use client'

import { Plan } from '@/models/Plan'
import { SessionDataResult } from '@/models/SessionDataResult'
import { currencyFormat } from '@/utils/CurrencyFormatter'
import { ConditionalWrapper } from '@supplement-bacon/react-toolkit/utils'
import { Badge, Card, Flex, Space, Typography, theme } from 'antd'

const { Title, Text } = Typography

interface Props {
  plan: Plan
  isSelected?: boolean
  onClick?: () => void
  displayDescriptions?: boolean
  amount?: SessionDataResult['amount']
  amountWithoutCoupon?: SessionDataResult['amountWithoutCoupon']
}

export const PlanCard = ({
  plan,
  isSelected = false,
  onClick,
  displayDescriptions = false,
  amount,
  amountWithoutCoupon,
}: Props) => {
  const { token } = theme.useToken()

  return (
    <ConditionalWrapper
      condition={plan.badgeText != undefined}
      wrapper={(children) => (
        <Badge.Ribbon text={plan.badgeText}>{children}</Badge.Ribbon>
      )}
    >
      <Card
        variant={!isSelected ? 'borderless' : undefined}
        onClick={onClick}
        style={{
          borderWidth: isSelected ? 2 : 0,
          borderColor: token.colorPrimary,
          pointerEvents: plan.isDisabled ? 'none' : undefined,
          opacity: plan.isDisabled ? 0.6 : 1,
        }}
      >
        <Flex align={'center'} justify="space-between">
          <Flex vertical style={{ maxWidth: '50%' }}>
            <Title level={5} style={{ margin: 0 }}>
              {plan.name}
            </Title>
            {plan.nameDescription && (
              <Text type="secondary">{plan.nameDescription}</Text>
            )}
          </Flex>
          {amount && amountWithoutCoupon && (
            <Space vertical size={0} style={{ alignItems: 'flex-end' }}>
              <Title level={5} style={{ margin: 0 }}>
                {currencyFormat(amount.value, amount.currencySymbol, true)}
              </Title>

              {amount.value !== amountWithoutCoupon.value && (
                <Text style={{ margin: 0, textDecoration: 'line-through' }}>
                  {currencyFormat(
                    amountWithoutCoupon.value,
                    amountWithoutCoupon.currencySymbol,
                    true
                  )}
                </Text>
              )}
            </Space>
          )}
          {displayDescriptions && (
            <Space vertical size={0} style={{ alignItems: 'flex-end' }}>
              <Title level={5} style={{ margin: 0 }}>
                {plan.description1}
              </Title>
              <Text type="secondary">{plan.description2}</Text>
            </Space>
          )}
        </Flex>
      </Card>
    </ConditionalWrapper>
  )
}
